/*******************************************************
 ***************************************** removeOrphans
 *******************************************************/
(function($){
  $.fn.removeOrphans = function(){
    if($(this).length > 0) {
      $(this).each(function(){
        var $html = $(this).html();
        $html = $html.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;");10
        $(this).empty().html($html);
      });
    }
  }
})(jQuery);